export enum BackDateType {
  NoBackDate = -1,
  OneMonth = 1,
  TwoMonths = 2,
  SevenMonths = 7,
  OneYear = 12,
}
